export const SEARCH_CITYNAME = "SEARCH_CITYNAME";
export const WEATHER_DATA_LOADING = "WEATHER_DATA_LOADING";
export const WEATHER_DATA_FAILED = "WEATHER_DATA_FAILED";
export const WEATHER_DATA = "WEATHER_DATA";
export const WEATHER_DATA_COORDS = "WEATHER_DATA_COORDS";

export const UPDATE_COORDS = "UPDATE_COORDS";
export const FAILED_COORDS = "FAILED_COORDS";

// This is just chilling here for now.
export const APPID = "bab8c6ff9bfc432f96e7542398423d15";
export const GEOCODEAPPID = "6928d9b230c742bc967f83abfe42e078";

export const ADD_FEEDBACK = "ADD_FEEDBACK";
